import React from "react";
import {ButtonWithConfirmation} from "./ButtonWithConfirmation";

interface ButtonsWithConfirmationPropsInterface {
    item: Object;
    buttons: any[];
}

export function ButtonsWithConfirmation({item, buttons}: ButtonsWithConfirmationPropsInterface) {
    return (
        <>
            {buttons.map((button, i) => {
                if (button.func && item[button.hideButtonParam]) {
                    const func = () => button.func(
                        button.funcParam
                            ? button.funcParam instanceof Array
                                ? button.funcParam.map((param) => item[param])
                                : item[button.funcParam]
                            : {item, id: button.filterParam},
                    );

                    const funcToCheckBeforeConfirmation = () => button.funcToCheckBeforeConfirmation(
                        button.funcToCheckBeforeConfirmationParam
                            ? button.funcToCheckBeforeConfirmationParam instanceof Array
                                ? button.funcToCheckBeforeConfirmationParam.map((param) => item[param])
                                : item[button.funcToCheckBeforeConfirmationParam]
                            : {item, id: button.filterParam}
                    );

                    return (
                        <ButtonWithConfirmation
                            key={i}
                            button={button}
                            func={button.func && func}
                            funcToCheckBeforeConfirmation={button.funcToCheckBeforeConfirmation && funcToCheckBeforeConfirmation}
                        />
                    );
                }

                return <div key={i} style={{'minHeight': "42px"}}></div>;
            })}
        </>
    );
}